import React, { useEffect, useState } from 'react'
import { Flex, Button, Text } from '@chakra-ui/react'
import ProgressBar from './application-progressbar'
import { UserProperty } from '../../generated/graphql'
import { ContainerHeading } from '../Headings'
import { capitalizeFirstLetter } from '../../helpers'
import { OnBoardingModal } from '../Modals'
import { useNavigate } from 'react-router-dom'

type ProgressType = {
  property: UserProperty
  onboardingStepsCompleted: number
}
const ApplicationProgressContainer: React.FC<ProgressType> = ({
  property,
  onboardingStepsCompleted
}) => {
  const [propertyStep, setPropertyStep] = useState<number>(0)
  const [showOnboardingModal, setShowOnboardingModal] = useState<boolean>(false)
  const [completedStepCount, setCompletedStepCount] = useState<number>(5)
  const [onboardingCompleted, setOnboardingCompleted] = useState<boolean>(false)
  const navigate = useNavigate()

  const { installationComplete, installationProcessInitiated, recordId } = property

  useEffect(() => {
    if (onboardingStepsCompleted) {
      setCompletedStepCount(onboardingStepsCompleted)
    }
  }, [onboardingStepsCompleted])

  useEffect(() => {
    const orderStatus = property.orderStatus
    if (orderStatus === 'App assist') {
      setPropertyStep(0)
    }
    if (orderStatus === 'Agreement Signed' || orderStatus === 'Agreement Signed (incomplete)') {
      setPropertyStep(1)
    }
    if (orderStatus === 'Once-Off Admin Fee Invoice Sent') {
      setPropertyStep(2)
    }
    if (property.installationComplete || property.installationProcessInitiated) {
      setPropertyStep(3)
    }

    if (
      orderStatus === 'Agreement Signed' ||
      orderStatus?.toLowerCase().includes('agreement signed') ||
      installationComplete ||
      installationProcessInitiated
    ) {
      setOnboardingCompleted(true)
    }
  }, [])

  return (
    <Flex
      w={'100%'}
      p="25px"
      h="100%"
      alignItems={'center'}
      justifyContent={'center'}
      rounded={'8px'}
      maxH={'100%'}
      display="flex"
      bgColor="brand.neutral"
      direction={'column'}
      key={`${property.propertyLat}-${property.recordId}`}
      gap="25px"
      shadow={'md'}
      pb="50px"
    >
      <ContainerHeading title="Application progress" />
      <Flex
        alignItems={'center'}
        justifyContent={'center'}
        direction={['column', 'column', 'row', 'row']}
        gap="25px"
        pb={5}
      >
        <Flex
          textAlign={'center'}
          alignItems={'center'}
          justifyContent={'center'}
          direction={['column', 'column', 'row', 'row']}
          gap="25px"
        >
          <Flex direction={'column'} gap="10px">
            <Text fontSize={'14px'} color={'brand.text.primary'}>
              <b>Type:</b>{' '}
              {capitalizeFirstLetter(
                property?.subscription?.subscriptionOption?.replace('2023_', '') as string
              )}{' '}
              subscription
            </Text>
            <Text fontSize={'14px'} color={'brand.text.primary'}>
              <b>Address:</b>
            </Text>
            <Text fontSize={'14px'} color={'brand.text.primary'}>
              {property.fullAddress}
            </Text>
            <Text fontSize={'14px'} color={'brand.text.primary'}>
              <b>Order status:</b> {property.orderStatus?.replace(' (incomplete)', '')}
            </Text>
            <Text fontSize={'14px'} color={'brand.text.primary'}>
              <b>Installation date:</b>{' '}
              {property.installationDate ? property.installationDate : 'Not set'}
            </Text>
          </Flex>
        </Flex>
        <Flex w={'100%'} alignItems={'center'} justifyContent="center">
          <ProgressBar stepsCompleted={propertyStep} />
        </Flex>
      </Flex>

      {completedStepCount < 9 && !onboardingCompleted && (
        <Button variant={'dark'} onClick={() => setShowOnboardingModal(true)}>
          Continue onboarding
        </Button>
      )}

      {onboardingCompleted && (
        <Button
          variant={'dark'}
          onClick={() => navigate(`/user/optional-uploads/${property.recordId}`)}
        >
          Optional uploads
        </Button>
      )}

      {showOnboardingModal && (
        <OnBoardingModal
          isOpen={showOnboardingModal}
          onClose={() => setShowOnboardingModal(false)}
          recordId={property.recordId}
          step={completedStepCount}
        ></OnBoardingModal>
      )}
    </Flex>
  )
}

export default ApplicationProgressContainer
